import { render } from "./ValueDriverModal.vue?vue&type=template&id=8855a4c2"
import script from "./ValueDriverModal?vue&type=script&lang=js"
export * from "./ValueDriverModal?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__